import { HttpInterceptorFn } from '@angular/common/http';
import { inject, LOCALE_ID } from '@angular/core';

/**
 * Sends the app's active locale as `Accept-Language` so the backend localizes
 * user-facing responses (errors, validation) and user-triggered emails (e.g.
 * password reset) to the language the user is actually seeing - independent of
 * any organization's country.
 */
export const localeInterceptor: HttpInterceptorFn = (req, next) => {
  const locale = inject(LOCALE_ID);
  return next(req.clone({ setHeaders: { 'Accept-Language': locale } }));
};
